import { getClassName } from "@pairtreefamily/utils";
import Close from "../icons/close";
import Lightbox from "../lightbox";

export type CarouselProps = {
  mediaUrl: string;
  mediaDescription?: string;
  onNext: () => void;
  onPrev: () => void;
  onClose: () => void;
  disablePrev?: boolean;
  disableNext?: boolean;
};

export function Carousel(props: CarouselProps) {
  return (
    <Lightbox>
      <button
        onClick={props.onClose}
        className={getClassName(
          "mx-2 rounded-full border-2 border-white p-[16px]",
          "fixed right-2 top-2",
        )}
      >
        <Close className="text-white" />
      </button>
      <button
        disabled={props.disablePrev}
        onClick={props.onPrev}
        className={getClassName(
          "mx-2 rounded-full border-[1px] border-gray p-[16px] disabled:opacity-50",
          "fixed left-2 top-[50%]",
          "bg-lightgray",
        )}
      >
        <img src="/left_arrow.svg" alt="left-facing arrow" />
      </button>
      <img
        src={props.mediaUrl}
        alt={props.mediaDescription}
        className="h-full w-full object-contain"
      />
      {/* TODO generalize as icon button if needed elsewhere */}
      <button
        disabled={props.disableNext}
        className={getClassName(
          "mx-2 rounded-full border-[1px] border-gray p-[16px] disabled:opacity-50",
          "fixed right-2 top-[50vh]",
          "bg-lightgray",
        )}
        onClick={props.onNext}
      >
        <img src="/right_arrow.svg" alt="right-facing arrow" />
      </button>
    </Lightbox>
  );
}

export default Carousel;
